import { render, staticRenderFns } from "./ExtensionChooser.vue?vue&type=template&id=3bd2779f&scoped=true"
import script from "./ExtensionChooser.vue?vue&type=script&lang=js"
export * from "./ExtensionChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd2779f",
  null
  
)

export default component.exports